import {
  useGetAlphaCatalogueQuery,
  useGetBankListQuery,
  useGetCountriesQuery,
  useGetCurrenciesQuery,
  useGetGendersQuery,
  useGetIdentityCardTypesQuery,
  useGetPhoneNumbersQuery,
  useGetRoundTypeQuery,
  useGetVatRatesQuery,
} from '@dms/api/core';
import {useGetCurrentUserInfoQuery} from '@dms/api/customer';

import {ComponentChildren} from 'shared/web';

export function InitializeMockData(props: ComponentChildren) {
  const {data: _currentUserInfo, isLoading: isCurrentUserInfoLoading} =
    useGetCurrentUserInfoQuery();
  const {data: _alphaCatalogue, isLoading: isAlphaCatalogueLoading} = useGetAlphaCatalogueQuery({
    lang: 'EN',
  });
  const {data: _phoneNumbers, isLoading: isPhoneNumbersLoading} = useGetPhoneNumbersQuery();
  const {data: _countries, isLoading: isCountriesLoading} = useGetCountriesQuery();
  const {data: _currencies, isLoading: isCurrenciesLoading} = useGetCurrenciesQuery();
  const {data: _genders, isLoading: isGendersLoading} = useGetGendersQuery();
  const {data: _bankList, isLoading: isBankListLoading} = useGetBankListQuery({countryCode: 'CZE'});
  const {data: _identityCardTypes, isLoading: isIdentityCardTypesLoading} =
    useGetIdentityCardTypesQuery();
  const {data: _roundType, isLoading: isRoundTypeLoading} = useGetRoundTypeQuery();
  const {data: _vatRate, isLoading: isVatRateLoading} = useGetVatRatesQuery();

  const isLoading =
    isCurrentUserInfoLoading ||
    isAlphaCatalogueLoading ||
    isPhoneNumbersLoading ||
    isCountriesLoading ||
    isCurrenciesLoading ||
    isGendersLoading ||
    isBankListLoading ||
    isIdentityCardTypesLoading ||
    isRoundTypeLoading ||
    isVatRateLoading;

  if (isLoading) {
    return;
  }

  return <div data-testid="Loaded">{props.children}</div>;
}
